import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useAuthState } from 'react-firebase-hooks/auth';
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

import { Loading } from './Loading';

const db = firebase.firestore();

const CurrentUser = ({ downloadUrl }) => {
  const { initialising, user } = useAuthState(firebase.auth());

  const logout = () => firebase.auth().signOut();

  if (initialising) return <Loading />;

  if (user) {
    return (
      <>
        <Link to="/profile">
          <ProfileImage backgroundImage={downloadUrl} />
        </Link>
        <LogoutWrapper>
          <Link to="/profile">You</Link>
          <button onClick={logout}>Logout</button>
        </LogoutWrapper>
      </>
    );
  }
  return (
    <p>
      <Link to="/login">Login</Link> | <Link to="/signup">Sign up</Link>
    </p>
  );
};

export const Header = () => {
  const { user } = useAuthState(firebase.auth());
  const [avatar, setAvatar] = useState();

  useEffect(
    () => {
      const downloadUrl = async () => {
        const doc = await db
          .collection('userPhotos')
          .doc(user && user.uid)
          .get();

        const data = doc.data();

        if (data && data.downloadUrl) {
          setAvatar(data && data.downloadUrl);
        }
      };

      downloadUrl();
    },
    [user]
  );

  return (
    <ProfileWrapper>
      <Link to="/">
        <h1>ErrandList</h1>
      </Link>
      <Profile>
        <CurrentUser downloadUrl={avatar} />
      </Profile>
    </ProfileWrapper>
  );
};

const ProfileWrapper = styled.div`
  display: flex;
  font-family: sans-serif;
  justify-content: space-between;
  margin-bottom: 20px;

  a {
    text-decoration: none;
  }

  h1 {
    font-size: 1.75rem;
    color: #c8c8c8;
  }
`;

const Profile = styled.div`
  display: flex;
  align-items: center;

  a {
    font-size: 1.2rem;
    color: var(--theme-secondary-color);
    font-weight: bold;
    text-decoration: none;
  }
`;

const ProfileImage = styled.div`
  height: 50px;
  width: 50px;
  display: block;
  background-color: white;
  border-radius: 30px;
  margin-right: 20px;
  background-image: ${props =>
    props.backgroundImage ? `url('${props.backgroundImage}')` : ''};
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
`;

const LogoutWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;

  a,
  button {
    display: block;
    flex-basis: 100%;
  }

  button {
    background: none;
    border: none;
    text-align: left;
    padding: 0px 0px 0px 0px;
    margin-top: 10px;
    color: #c8c8c8;
  }
`;
